import { styled, Input } from "@woba/ds-web";
import * as Alert from "@radix-ui/react-alert-dialog";

export const AlertDialogOverlay = styled(Alert.Overlay, {
  backgroundColor: "rgba(0, 0, 0, 0.44)",
  position: "fixed",
  inset: 0,
});

export const AlertDialogContent = styled(Alert.Content, {
  backgroundColor: "white",
  borderStyle: "solid",
  borderWidth: "$border-01",
  borderColor: "$neutral-400",
  borderRadius: 8,
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "600px",
  padding: 32,

  "&:focus": { outline: "none" },
});

export const AlertContainer = styled("div", {
  position: "relative",
});

export const CloseContainer = styled("div", {
  position: "absolute",
  right: 0,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "4px",
  borderWidth: "$border-01",
  borderStyle: "solid",
  borderColor: "transparent",
  padding: 10,

  "&:hover": {
    borderRadius: "4px",
    borderWidth: "$border-01",
    borderStyle: "solid",
    borderColor: "$neutral-200",
    backgroundColor: "$neutral-100",
    padding: 10,
  },
});

export const AlertDialogTitle = styled(Alert.Title, {
  margin: 0,
  color: "$neutral-900",
  fontSize: "2rem",
  fontWeight: 700,
  lineHeight: "40px",
  letterSpacing: "-0.5px",
});

export const AlertDialogDescription = styled(Alert.Description, {
  marginTop: 10,
  marginBottom: 32,
  color: "$neutral-700",
  fontSize: "$md",
  fontWeight: 400,
  lineHeight: "24px",
});

export const AlertDialogWarning = styled(AlertDialogDescription, {
  margin: "0 0 0 16px",
});

export const AlertInfo = styled("div", {
  display: "flex",
  padding: "1rem",
  alignItems: "center",
  marginTop: "16px",
  marginBottom: "32px",
  borderRadius: "4px",
  backgroundColor: "$neutral-100",
});

export const AlertDialogDivider = styled("hr", {
  margin: "auto -32px 32px",
  borderWidth: "$border-01",
  borderColor: "$neutral-200",
  borderStyle: "solid",
});

export const FooterDialog = styled("div", {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: 32,
});

export const AlertDialogErrorLabel = styled("span", {
  display: "inline-flex",
  alignItems: "center",
  marginTop: "$space-02",
  gap: "$space-02",
  fontSize: "$sm",
  color: "$danger-700",
  svg: {
    width: "16px",
  },
});
